<template>
  <div>
    <Header></Header>
    <point-form></point-form>
    <point-table></point-table>
  </div>
</template>

<script>
import PointForm from "@/components/dashboard/point/PointForm";
import PointTable from "@/components/dashboard/point/PointTable";
import Header from "@/components/dashboard/Header";
export default {
  components: {
    Header,
    PointForm,
    PointTable
  }
};
</script>

<style scoped>
</style>
